import { useEffect, useState } from 'react';

export const useLocalStorage = (defaultValue: string, key: string): any => {
    const [value, setValue] = useState(() => {
        const stickyValue = localStorage.getItem(key);

        return stickyValue !== null ? JSON.parse(stickyValue) : defaultValue;
    });

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
};
